import { ExtendedValidationMessages } from 'commons/components/form-elements/assistive-text';
import {
    NestedSelectableOptions,
    SelectableOptions,
} from 'commons/components/searchable-dropdown/searchable-dropdown.type';
import type { PocInputValidity } from 'commons/types';
import { useTranslation } from 'core/i18n/i18n';
import {
    FormSection,
    FormSectionHint,
    FormSectionTitle,
    FullWidthSearchableDropdown,
} from 'modules/settings/components/custom-notifications/custom-notification-form.style';

export interface CustomNotificationMultiSelectSectionProps {
    name: string;
    titleKey: string;
    placeholderKey: string;
    hintKey?: string;
    options: SelectableOptions[] | NestedSelectableOptions[];
    draftIds: string[];
    selectedIds: string[];
    isLoading?: boolean;
    searchable?: boolean;
    expandGroupsByDefault?: boolean;
    disableEmptyGroups?: boolean;
    validity?: PocInputValidity;
    validationMessages?: ExtendedValidationMessages;
    onDraftChange: (value: string[]) => void;
    onApplySelection: (value: string[]) => void;
    onClear?: VoidFunction;
}

export const CustomNotificationMultiSelectSection: React.FC<CustomNotificationMultiSelectSectionProps> = ({
    name,
    titleKey,
    placeholderKey,
    hintKey,
    options,
    draftIds,
    selectedIds,
    isLoading,
    searchable,
    expandGroupsByDefault,
    disableEmptyGroups,
    validity,
    validationMessages,
    onDraftChange,
    onApplySelection,
    onClear,
}) => {
    const { t } = useTranslation();

    return (
        <FormSection>
            <FormSectionTitle variant="subtitle2">{t(titleKey)}</FormSectionTitle>
            <FullWidthSearchableDropdown
                name={name}
                placeholder={t(placeholderKey)}
                options={options}
                size="small"
                value={draftIds}
                secondaryValue={selectedIds}
                searchable={searchable}
                isLoading={isLoading}
                expandGroupsByDefault={expandGroupsByDefault}
                disableEmptyGroups={disableEmptyGroups}
                validity={validity}
                validationMessages={validationMessages}
                onValueChange={onDraftChange}
                onApplySelection={onApplySelection}
                onClear={onClear}
            />
            {hintKey ? <FormSectionHint variant="body2">{t(hintKey)}</FormSectionHint> : null}
        </FormSection>
    );
};
